import { AntCard as Card, Tooltip } from "@murm/ant";
import styles from "../DataCatalog.module.css";
import { PENDO_ID, pendoId } from "../../../lib/pendoIds";
import { cx } from "../../../lib/classNames";

/**
 * Feature / filter-value card. A selected card is outlined in the primary color — the Figma uses
 * one accent across the catalog's tabs, so the outline no longer varies per tab.
 */
export const FeatureButton = ({ feature, description, onClick, selected }) => {
  const card = (
    <Card
      {...pendoId(PENDO_ID.CATALOG_FEATURE)}
      hoverable={!selected}
      onClick={onClick}
      className={cx(styles.card, styles.featureCard, selected && styles.selected)}
      classNames={{ body: styles.featureBody }}
    >
      <span className={styles.cardLabel}>{feature}</span>
    </Card>
  );

  if (!description?.trim()) return card;
  return <Tooltip title={description}>{card}</Tooltip>;
};
